/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Spaces_Created_By_MemberInputs */



/**
* | output |
* | --- |
* | "Created by them" |
*
* @param {Member_Spaces_Created_By_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_spaces_created_by_member = /** @type {((inputs?: Member_Spaces_Created_By_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Spaces_Created_By_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von diesem Mitglied erstellt")
	return /** @type {LocalizedString} */ ("Created by them")
});